import { render, staticRenderFns } from "./CreateChatSocialModal.vue?vue&type=template&id=01e0510d"
import script from "./CreateChatSocialModal.vue?vue&type=script&lang=js"
export * from "./CreateChatSocialModal.vue?vue&type=script&lang=js"
import style0 from "./CreateChatSocialModal.vue?vue&type=style&index=0&id=01e0510d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports